import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePaginationActions from "../../../../../../globals/components/TablePaginationActions";
import { CarrierTabEmptyRow, CarrierTabLoadingRow } from "./carrierTabTablePrimitives";

export default function CarrierCommissionsTabPanel({ vm }) {
  const {
    setOpenCommissionDialog,
    handleDeleteCommission,
    rowsPerPageCommissions,
    handleOpenUpdateCommissionDialog,
    commissionLoading,
    handleChangePageCommissions,
    handleChangeRowsPerPageCommissions,
    paginationSx,
    formatDate,
    commissions,
    headerRowSx,
    pageCommissions,
    tableCardSx,
  } = vm;

  const renderBody = () => {
    if (commissionLoading) {
      return <CarrierTabLoadingRow colSpan={4} />;
    }
    if (commissions.length === 0) {
      return <CarrierTabEmptyRow colSpan={4} message="No commissions found." />;
    }
    const slice = commissions.slice(
      pageCommissions * rowsPerPageCommissions,
      pageCommissions * rowsPerPageCommissions + rowsPerPageCommissions,
    );
    return slice.map((commission) => (
      <TableRow key={commission.commission_id}>
        <TableCell>{commission.bond_type_display.name}</TableCell>
        <TableCell align="right">{commission.commission_percent}%</TableCell>
        <TableCell align="right">{formatDate(commission.effective_date)}</TableCell>
        <TableCell align="center">
          <IconButton color="primary" onClick={() => handleOpenUpdateCommissionDialog(commission.commission_id)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteCommission(commission.commission_id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenCommissionDialog(true)}
        >
          Add Commission
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>Bond Type</TableCell>
              <TableCell align="right">Percentage</TableCell>
              <TableCell align="right">Effective Date</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        component="div"
        count={commissions.length}
        page={pageCommissions}
        onPageChange={handleChangePageCommissions}
        rowsPerPage={rowsPerPageCommissions}
        onRowsPerPageChange={handleChangeRowsPerPageCommissions}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={paginationSx}
      />
    </>
  );
}

CarrierCommissionsTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
